import React, {useEffect, useMemo, useState} from "react";
import CustomDialog from "../../components/general/CustomDialog";
import {useTranslation} from "react-i18next";
import getConstrains from "../../utils/validationConstraints";
import useValidation from "../../hooks/useValidation";
import useInputValue from "../../hooks/useInputValue";
import CustomInput from "../../components/general/CustomInput";
import CustomTextArea from "../../components/general/CustomTextArea";
import CustomDatePicket from "../../components/general/CustomDatePicket";
import {UserDepartmentInterface} from "../../services/interface/UserDepartmentInterface";
import {toBase64} from "../../utils/fileBase64";
import FileUpdate from "../../components/general/file-update/FileUpdate";
import {DocumentProcessInterface} from "../../services/interface/DocumentProcessInterface";
import CustomButton from "../../components/general/CustomButton";
import {useListAllUsersStatus} from "../../services/admin-user/apiUsers";
import {UserInterface} from "../../services/interface/UserInterface";
import {ListItem, Navbar} from "@material-tailwind/react";
import {CustomCheckbox} from "../../components/general/CustomCheckbox";
import {ProcessInterface} from "../../services/interface/ProcessInterface";
import {showToast} from "../../components/general/CustomToast";
import {useCreateProcess, usePermissionProcess, useSaveDocumentProcess} from "../../services/process/apiProcess";
import {enqueueSnackbar} from "notistack";
import {PermissionEnum} from "../../services/enum/PermissionConst";
import {ProcessDto} from "../../services/interface/ProcessDtoInterface";
import {formatTypeDate} from "../../utils/daysOptions";
import {useProcessStore} from "../../services/storage/process/ProcessStorage";
import {DescriptionFileInterface} from "../../services/interface/DescriptionFileInterface";

interface Props {
    title: string;
    department?: UserDepartmentInterface;
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    processDB?: ProcessDto;
}

export default function DialogCreateProcess({title, open, setOpen, department, processDB}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }
    const dialogBodyRef = React.useRef<HTMLDivElement | null>(null);
    const setProcessStorage = useProcessStore(data => data.setData)

    const {refetch: findAllUsers, isPending, data} = useListAllUsersStatus()
    const {mutate: createProcess, isPending: isLoadingCreate, data: successCreate} = useCreateProcess();
    const {mutate: permissionProcess, isPending: isLoadingPermission, data: successPermission} = usePermissionProcess();
    const {mutate: saveDoc, isPending: isLoadingDocumentSave, data: successDocumentSave} = useSaveDocumentProcess();
    const [process, setProcess] = React.useState<ProcessInterface | undefined>()

    const [option, setOption] = useState(t('attach-docs'))

    const [list, setList] = React.useState<UserInterface[] | undefined>()

    useEffect(() => {
        findAllUsers({});
    }, []);

    useEffect(() => {
        if (data && data.length > 0) {
            if (processDB &&
                ((processDB.usersAttachDocs && processDB.usersAttachDocs.length > 0) ||
                    (processDB.usersDeleteDocs && processDB.usersDeleteDocs.length > 0)
                )
            ) {
                let listPermission: UserInterface[] = data;
                processDB.usersAttachDocs?.forEach(item => {
                    listPermission = listPermission.map((user) => {
                        if (user.username === item.idUser) {
                            return {...user, checkAddDocuments: true}
                        }
                        return user
                    })
                })
                processDB.usersDeleteDocs?.forEach(item => {
                    listPermission = listPermission.map((user) => {
                        if (user.username === item.idUser) {
                            return {...user, checkDeleteDocuments: true}
                        }
                        return user
                    })
                })
                setList(listPermission)
            } else {
                setList(data)
            }
        }
    }, [data, processDB]);

    const [errorValidation, setErrorValidation]: any = useState(null);
    const validationSchema = useMemo(
        () => getConstrains(['name', 'date']),
        []
    );
    const validation = useValidation(validationSchema);

    const name = useInputValue('')
    const description = useInputValue('')
    const [date, setDate] = useState<Date | undefined>()
    const [files, setFiles] = useState<File[]>([]);
    const [descriptions, setDescriptions] = useState<DescriptionFileInterface[]>([]);
    const [filesFormat, setFilesFormat] = useState<DocumentProcessInterface[]>([]);

    useEffect(() => {
        if (processDB && title) {
            name.onChangeText(processDB?.name ? processDB.name : '')
            description.onChangeText(processDB?.description ? processDB.description : '')
            setDate(processDB?.date ? formatTypeDate(processDB.date) : undefined)
            setProcess({
                idProcess: processDB.idProcess,
                idDepartment: department?.idDepartment,
            })
        }
    }, [processDB, title]);

    useEffect(() => {
        if (files && files.length > 0) {
            const filesBase64: DocumentProcessInterface[] = []
            files.forEach(item => {
                toBase64(item)
                    .then((base64String) => {
                        const aux: any = base64String ? base64String : ','
                        const file: DocumentProcessInterface = {
                            name: item.name,
                            type: item.type,
                            size: item.size,
                            file: aux.split(',')[1],
                            date: new Date()
                        }
                        filesBase64.push(file)
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            })
            setFilesFormat(filesBase64)
            scrollAction()
        }
    }, [files]);

    const scrollAction = () => {
        if (dialogBodyRef && dialogBodyRef.current && dialogBodyRef.current?.scrollHeight && dialogBodyRef.current?.clientHeight) {
            const fullHeight = dialogBodyRef.current?.scrollHeight - dialogBodyRef.current?.clientHeight;

            dialogBodyRef.current?.scrollTo({
                top: fullHeight,
                behavior: 'smooth',
            });
        }
    }

    const styleMenu = 'flex justify-center items-center gap-2 py-2 pr-4 text-white';

    useEffect(() => {
        if (successCreate && successCreate?.idProcess) {
            setProcess(successCreate)
            enqueueSnackbar('Proceso generado exitosamente', { variant: 'success' });
            const listAddDocuments = list?.filter(item => item.checkAddDocuments);
            const listUsersAdd: string[] = [];
            listAddDocuments?.map(user => {
                if (user.username) {
                    listUsersAdd.push(user.username);
                }
            })
            const listDeleteDocuments = list?.filter(item => item.checkDeleteDocuments);
            const listUsersDelete: string[] = [];
            listDeleteDocuments?.map(user => {
                if (user.username) {
                    listUsersDelete.push(user.username);
                }
            })
            if (listUsersAdd.length > 0) {
                enqueueSnackbar('Asignando permisos de carga de documentos', { variant: 'info' });
                permissionProcess({idProcess: successCreate?.idProcess, idPermission: PermissionEnum.CREATE, idUsers: listUsersAdd});
            }
            if (listUsersDelete.length > 0) {
                enqueueSnackbar('Asignando permisos de eliminación de documentos', { variant: 'info' });
                permissionProcess({idProcess: successCreate?.idProcess, idPermission: PermissionEnum.DELETE, idUsers: listUsersDelete});
            }
            if (filesFormat && filesFormat.length > 0) {
                enqueueSnackbar('Guardando documentación en el repositorios', { variant: 'info' });
                filesFormat.forEach((file, index) => {
                    const descriptionItem = descriptions.find(item => item.index === index);
                    saveDoc({
                        ...file,
                        idProcess: successCreate?.idProcess,
                        ...(descriptionItem?.description ?
                            {description: descriptionItem.description} : {})
                    });
                })
            }
        }
    }, [successCreate]);

    useEffect(() => {
        if (successPermission) {
            enqueueSnackbar(`Permisos asignados exitosamente`, { variant: 'success' });
            setTimeout(() => {setProcessStorage(process)}, 5000);
            setOpen(false)
        }
    }, [successPermission]);

    useEffect(() => {
        if (successDocumentSave) {
            setTimeout(() => {setProcessStorage(process)}, 5000);
            setOpen(false)
        }
    }, [successDocumentSave]);

    return (
        <CustomDialog
            loading={isPending}
            title={title}
            body={
                <div className={'flex flex-col gap-3'} ref={dialogBodyRef}>
                    <div className={'flex flex-row gap-5'}>
                        <CustomInput
                            type={'text'}
                            labelFixel={true}
                            label={t('process')}
                            error={errorValidation?.name}
                            {...name}
                        />
                        <CustomDatePicket
                            label={t('date')}
                            value={date}
                            setValue={setDate}
                            error={errorValidation?.date}
                        />
                    </div>
                    <CustomTextArea
                        label={t('description')}
                        labelFixel={true}
                        {...description}
                    />
                    <Navbar placeholder={''} className="mx-auto max-w-screen-xl px-4 py-2 bg-primary">
                        <div className="flex items-center justify-between text-blue-gray-900 gap-6">
                            <ListItem
                                selected={option === t('attach-docs')}
                                placeholder={''}
                                className={styleMenu}
                                onClick={() => {setOption(t('attach-docs'))}}>
                                {t('attach-docs')}
                            </ListItem>
                            <ListItem
                                selected={option === t('permissions')}
                                placeholder={''}
                                className={styleMenu}
                                onClick={() => {setOption(t('permissions'))}}>
                                {t('permissions')}
                            </ListItem>
                        </div>
                    </Navbar>
                    <div className={'min-h-[150px]'}>
                        {t('attach-docs') === option &&
                            <FileUpdate
                                accept={'.pdf,.zip,.rar'}
                                acceptDragAndDrop={[
                                    'application/pdf',
                                    'application/x-rar-compressed',
                                    'application/zip',
                                    'application/x-zip-compressed', // compatibilidad para navegadores antiguos
                                ]}
                                {...{files, setFiles, descriptions, setDescriptions}}
                            />
                        }
                        {t('permissions') === option && <SelectUsersPermission {...{list, setList}}/>}
                    </div>
                    <CustomButton
                        className={'bg-success ml-auto'}
                        text={t('save')}
                        disabled={isLoadingCreate || isLoadingPermission}
                        loading={isLoadingCreate || isLoadingPermission || isLoadingDocumentSave}
                        onClick={() => {
                            const data: ProcessInterface = {
                                idProcess: process?.idProcess,
                                name: name.value,
                                description: description.value,
                                date: date,
                                idDepartment: department?.idDepartment,
                            }
                            const errors = validation(data);
                            if (errors !== null && Object.keys(errors).length) {
                                setErrorValidation(errors)
                                showToast(
                                    'Campos obligatorios por llenar (*)',
                                    'warning-info'
                                );
                            } else {
                                setErrorValidation(null);
                                createProcess(data)
                            }
                        }}
                    />
                </div>
            }
            {...{open, setOpen}}
        />
    )
}

interface SelectProps {
    list?: UserInterface[],
    setList: React.Dispatch<React.SetStateAction<UserInterface[] | undefined>>
}
function SelectUsersPermission({list, setList}: SelectProps) {
    const {t} = useTranslation("global") as { t: (key: string) => string }

    return(
        <div className={'grid grid-cols-1 sm:grid-cols-2 gap-3'}>
            <div className={'col-span-2 flex flex-row justify-end gap-2'}>
                <CheckOption
                    valueInit={false}
                    label={t('add-docs')}
                    event={() => {
                        if (list && list.length > 0) {
                            const value = list[0].checkAddDocuments === undefined ? true : !list[0].checkAddDocuments;
                            setList(list => (list?.map(user => {
                                return {
                                    ...user,
                                    checkAddDocuments: value
                                }
                            })))
                        }
                    }}
                />
                <CheckOption
                    valueInit={false}
                    label={t('delete-docs')}
                    event={() => {
                        if (list && list.length > 0) {
                            const value = list[0].checkDeleteDocuments === undefined ? true : !list[0].checkDeleteDocuments;
                            setList(list => (list?.map(user => {
                                return {
                                    ...user,
                                    checkDeleteDocuments: value
                                }
                            })))
                        }
                    }}
                />
            </div>
            {list && list.length > 0 && list.map((item: UserInterface, index) => (
                <div key={`check-${index}`} className={'!border border-1 rounded-[5px] px-2 grid grid-cols-1 xl:grid-cols-3 items-center'}>
                    <div><div className={'font-semibold truncate'}>{`${item.correo}`}</div>{`${item.nombre} ${item.apellido}`}</div>
                    <CustomCheckbox
                        classNameContent={'ml-auto'}
                        label={t('add-docs')}
                        event={() => {
                            setList(list => (list?.map(user => {
                                if (user.username === item.username) {
                                    return {...user, checkAddDocuments: user.checkAddDocuments === undefined ? true : !user.checkAddDocuments}
                                }
                                return user
                            })))
                        }}
                        value={item.checkAddDocuments !== undefined ? item.checkAddDocuments : false}
                    />
                    <CustomCheckbox
                        classNameContent={'ml-auto'}
                        label={t('delete-docs')}
                        event={() => {
                            setList(list => (list?.map(user => {
                                if (user.username === item.username) {
                                    return {...user, checkDeleteDocuments: user.checkDeleteDocuments === undefined ? true : !user.checkDeleteDocuments}
                                }
                                return user
                            })))
                        }}
                        value={item.checkDeleteDocuments !== undefined ? item.checkDeleteDocuments : false}
                    />
                </div>
            ))}
        </div>
    )
}

interface CheckProps {
    label: string;
    valueInit: boolean;
    event: any,
    item?: UserInterface;
}
function CheckOption({label, valueInit, event, item}: CheckProps) {
    const [checked, setChecked] = React.useState(valueInit);

    return (
        <CustomCheckbox
            value={checked}
            setValue={setChecked}
            event={() => {
                event()
                setChecked(!checked)
            }}
            {...{label}}
        />
    )
}
